import React from 'react'
import {
    ContactCalloutElm,
    ContactCalloutCopy
} from './ContactCalloutStyles'
import { PrimaryButton } from '../../styles'

const ContactCallout = ({heading}) => {
    return (
        <ContactCalloutElm>
            <ContactCalloutCopy>
                <h2>{heading}</h2>
                <PrimaryButton to={`/contact/`} modifiers={['grey']}>
                    Request A Free Quote Today
                </PrimaryButton>
            </ContactCalloutCopy>
        </ContactCalloutElm>
    )
}

export default ContactCallout
